import { Box, Center } from '@chakra-ui/react';
import React from 'react';

export const PageGradient = React.memo(() => {
  return (
    <Center>
      <Box
        bgGradient="radial(green.100, bgColor.100, bgColor.100)"
        opacity={'20%'}
        w={{ base: '100%', md: '80%' }}
        h={'1200px'}
        borderRadius={'50%'}
        position={'absolute'}
        top={{ base: '-600px' }}
        zIndex={-1}
      />
    </Center>
  );
});
